/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Filter_ListInputs */

const en_ui_filter_list = /** @type {(inputs: Ui_Filter_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose filter`)
};

const de_ui_filter_list = /** @type {(inputs: Ui_Filter_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter wählen`)
};

/**
* | output |
* | --- |
* | "Choose filter" |
*
* @param {Ui_Filter_ListInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_list = /** @type {((inputs?: Ui_Filter_ListInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_ListInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_list(inputs)
	return de_ui_filter_list(inputs)
});